module.exports = __webpack_public_path__ + "img/7b04c92.png";